<template>
  <div class="animated fadeIn">

    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col lg="12">
            <b-alert show variant="light">Pending Visitors</b-alert>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12">
             <b-button block variant="primary" @click="refresh">Refresh Records Manually</b-button>
          </b-col>
        </b-row>
          <b-col lg="12">
            <hr/>
          </b-col>
        <b-row>
        </b-row>
        <b-row>
          <b-col lg="12">
            <ag-grid-vue
                     class="ag-theme-balham"
                     id="samadhPendingVisitorsGrid"
                     :gridOptions="gridOptions"
                     :columnDefs="columns"
                     :rowData="pendingVisitorsList"
                     :rowClassRules="rowClassRules"
                     :frameworkComponents="frameworkComponents"
                     :pagination="true"
                     :paginationPageSize="50"
                      @gridReady="gridReady"
                      :suppressNoRowsOverlay="true"
                     >
            </ag-grid-vue>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>


<script>
  import { mapState } from 'vuex'
  import Vue from 'vue'
  import {AgGridVue} from "ag-grid-vue";
  import VisitActionsRenderer from './components/VisitActionsRenderer.js';
  export default {
    name: 'SamadhPendingVisitors',
    components: {
      AgGridVue
    },
    data: function() {
      return {
        visitors: [],
        gridOptions: {
          context: {
            componentParent: this
          },
          defaultColDef: {
            sortable: true,
            resizable: true,
            filter: 'agTextColumnFilter',
            minWidth: 120
          },
        },
        gridApi: null,
        columns : [],
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default',
        rowClassRules: null,
        timer: '',
        frameworkComponents: null,

      }
    },
    computed: {
      pendingVisitorsList: function(){
        return this.$store.state.samadh.pendingVisitors;
      }
    },
    methods: {
      refresh() {
        this.$store.dispatch('samadh/getPendingVisitors');
      },
      gridReady() {
      //  this.gridOptions.api.sizeColumnsToFit()
      }
    },
    created() {
      if (this.$store.state.samadh.pendingVisitors.length == 0) {
        this.$store.dispatch('samadh/getPendingVisitors')
      }
      this.timer = setInterval(this.refresh, 10000);
    },
    beforeDestroy(){
       clearTimeout(this.timer);
    },
    beforeMount() {
      this.columns = [
              {headerName: 'Name', field: 'name', sortable: true, filter: true},
              {headerName: 'Age', field: 'age', sortable: true, filter: true},
              {headerName: 'Mobile', field: 'mobile'},
              {headerName: 'Time Elapsed', field: 'timeElapsed',  filter: true,  minWidth: 200},
              {headerName: 'Security Clearance Time', field: 'securityExit',  sortable: true, filter: true},
              {headerName: 'Entry and Security Difference', field: 'securityEtnryTime',  sortable: true, filter: true},
              {headerName: 'Action', field: 'id', cellRenderer: 'visitActionsRenderer',colId: 'params'}

          ];
      this.rowClassRules = {
         'hours-threshold-warning': params => {
           var entryMinutes = params.data.entryMinutes;
           return entryMinutes >= 60 && entryMinutes <= 120;
         },
         'hours-threshold-breach': 'data.entryMinutes > 120',
         'hours-threshold-success': 'data.entryMinutes < 60',
      };
      this.frameworkComponents = {
        visitActionsRenderer: VisitActionsRenderer,
      };


    }
  }
</script>

<style>
  .hours-threshold-warning {
  background-color: sandybrown !important;
  }
  .hours-threshold-breach {
  background-color: lightcoral !important;
  }
  .hours-threshold-success {
  background-color: green !important;
  }
</style>
